import { DataHeader, DataSource, Panel, Textbox } from "@mcleod/components";
import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommLoginLogoutHist extends Layout {
    dataheaderMobileCommLoginLogoutHist: DataHeader;
    panelMobileCommLoginLogoutHist: Panel;
    sourceMcLoginLogoutHist: DataSource;
    textboxDriverId: Textbox;
    textboxLoginDate: Textbox;
    textboxLoginPositionId: Textbox;
    textboxLogoutDate: Textbox;
    textboxLogoutPositionId: Textbox;
    textboxTractorId: Textbox;
}
